import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Subscription } from 'rxjs';

import { SearchModeEnum } from '~/attendee/components/pages/home/filters/enum/search-mode.enum';
import { JumbotronVariantEnum } from '~/attendee/components/shared/jumbotron/enums/jumbotron-variant.enum';
import { UpdateFilterPayloadInterface } from '~/attendee/interfaces/update-filter-payload.interface';
import {
  HomepageCms,
  JumbotronCms,
} from '~/cms/interfaces/homepage.cms.interface';
import { CmsService } from '~/cms/services/cms/cms.service';
import { CustomHeadTagService } from '~/core/services/custom-head-tag/custom-head-tag.service';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-attendee-homepage',
  templateUrl: './homepage.component.html',
})
export class AttendeeHomepageComponent implements OnInit, OnDestroy {
  @Input() public isHp?: boolean;
  private readonly subscriptions = new Subscription();
  public readonly searchModeEnum = SearchModeEnum;

  public homeCms: HomepageCms;
  public isTabletDevice: boolean;

  constructor(
    private readonly cmsService: CmsService,
    private readonly matchMediaService: MatchMediaService,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly router: Router,
    private readonly customHeadTagService: CustomHeadTagService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.cmsService.getHomepage().subscribe((homepage) => {
        this.homeCms = homepage;
        this.customHeadTagService.addSeoTags(homepage?.SEO);
      })
    );

    this.subscriptions.add(
      this.matchMediaService.isTabletDevice().subscribe((isTabletDevice) => {
        this.isTabletDevice = isTabletDevice;
      })
    );
  }

  public get jumbotron(): JumbotronCms {
    return this.homeCms?.jumbotron;
  }

  public get jumbotronVariant(): JumbotronVariantEnum {
    return this.isTabletDevice
      ? JumbotronVariantEnum.WithoutPicture
      : JumbotronVariantEnum.Rounded;
  }

  // update filters with emited value from search filters
  public updateFilters(updatePayloads: UpdateFilterPayloadInterface[]): void {
    const filters = {
      page: 1,
    };

    updatePayloads.forEach((updatePayload) => {
      filters[updatePayload.field] = updatePayload.value;
    });

    this.router.navigate(
      [this.localizeRouterService.translateRoute('/q').toString()],
      {
        queryParams: {
          ...filters,
        },
        queryParamsHandling: 'merge', // keep other params
      }
    );
  }
}
